/* System defined core library */
import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { AppointmentService } from '../../shared/services/appointment/appointment.service';
import { SelectedExamDetailService } from '../../shared/services/selected-exam-detail.service';
import { UtilityService } from '../../../shared/services/utility.service';
import { ExamFeatureService } from '../../../shared/services/exam-feature.service';

/* User defined models */
import { EmailResponse } from '../../../shared/models/common/shared.model';
import { AppointmentSlot } from '../../../shared/models/scheduling/appointmentSlot.model';
import { PersonDetail } from '../../../shared/models/scheduling/personalDetail.model';
import { Candidate } from '../../../shared/models/scheduling/candidate.model';
import { AppointmentDetail } from '../../../shared/models/scheduling/appointmentdetail.model';
import { Booking } from '../../../shared/models/scheduling/booking.model';

/* User defined enums/constants */
import { ComponentType } from '../../../shared/enums/scheduling.enum';


@Component({
  selector: 'app-verification-detail',
  templateUrl: './verification-detail.component.html'
})
export class VerificationDetailComponent implements OnInit {

  /* User defined private/public variables  */
  public candidate: Candidate;
  public booking: Booking;
  public personDetail: PersonDetail;
  public confirmationNumber: string = '';
  public showPaymentDetail: boolean = true;

  /* Input-OutPut parameters decalartions */
  @Input() public emailResponse: EmailResponse = new EmailResponse();
  @Input() public appointmentDetails: AppointmentDetail[];

  /* Service subscriptions */
  candidateData$: Subscription;
  booking$: Subscription;
  translateLanguage$: Subscription;

  public totalExamDurations: number = 0;

  /* Constructor declaration with required injected services */
  constructor(
    private appointmentService: AppointmentService,
    private utilityService: UtilityService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService
  ) {

    this.booking$ = selectedExamDetailService.booking.subscribe(
      booking => {
        this.booking = booking;
      });

    this.candidateData$ = selectedExamDetailService.candidate.subscribe(
      candidate => {
        this.candidate = candidate;
        if (this.candidate) {
          this.personDetail = new PersonDetail(this.candidate.FirstName, this.candidate.LastName,
            this.candidate.AddressLine1, this.candidate.AddressLine2, this.candidate.AddressLine3,
            this.candidate.PrimaryPhoneNumber, this.candidate.EmailAddress);
        }
      });

    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      }
    )
    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    this.showPaymentDetail = !!this.appointmentDetails[0].payments.length;
    sessionStorage.setItem('previousUrl', window.location.pathname);
    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.VerificationDetailComponent)) return;

    if (this.booking != null && this.booking != undefined) {
      this.confirmationNumber = "";

      if (this.booking.tests != null && this.booking.tests != undefined) {
        this.booking.tests.forEach((bkDetail) => {
          //TODO: add session number next to confirmation -MR
          this.confirmationNumber += "<li>" + bkDetail.sessions[0].confirmationNumber + "</li>";
        });
        this.confirmationNumber = "<ul class='list-unstyled'>" + this.confirmationNumber + "</ul>";
      }

      if (this.appointmentDetails != null && this.appointmentDetails != undefined) {
        this.totalExamDurations = ExamFeatureService.calculateTotalDuration(this.appointmentDetails);
        this.appointmentDetails.forEach(appointmentDetail => {
          appointmentDetail.payments.forEach(payment => {
            payment.transactionType = (payment.transactionType.indexOf("Fee") > -1) ?
              payment.transactionType : payment.transactionType + " Fee";
            payment.transactionType = (this.selectedExamDetailService.currentTargetFlow == 'Schedule') ?
              "Exam Fee" : payment.transactionType;

            if (payment.description === 'RefundPayment') {
              payment.transactionType = 'Cancel Refund';
            }
          })
        });
      }
    }
  }

  getApptDetail(appointmentDetail: AppointmentDetail, sessionIndex: number) {
    if (appointmentDetail.exam.sessions && appointmentDetail.exam.sessions.length < 1) return appointmentDetail;
    const session = appointmentDetail.exam.sessions[sessionIndex];
    let appointmentSlot =
      new AppointmentSlot(
        null,
        null,
        new Date(this.utilityService.getFormatToFullMMDDYYYY(session.slot.startDateTime, "/")),
        session.duration,
        session.site,
        session.slot.testTime,
        session.slot.testEndTime
      );
    appointmentDetail.appointmentSlot = appointmentSlot;
    return appointmentDetail;
  }

  /* Set Search Performed as false when component in unloaded */
  ngOnDestroy() {
    this.selectedExamDetailService.isSearchPerformed = false;
  }

  //check if total duration can be displayed, based on the type of exam
  canShowDuration(): boolean {
    return this.appointmentService.canShowDuration(this.appointmentDetails);
  }
}
